import REST from '../rest';

const ENDPOINT = 'api/v1/me';

const load = () => REST.get(ENDPOINT);

export default load;
